export default "__VITE_ASSET__adfc68fe__"